import { MemberProps } from 'app/components/Core/convention'
import KTitle from 'app/components/UI-Elements/Layout/KTitle'
import { RecordType } from 'app/constants/GlobalTypes'
import useTitle from 'app/lib/hooks/useTitle'
import { Routes } from 'app/routes/Routes'
import { useNavigate } from 'react-router-dom'

const DamagesTitle: React.FC<MemberProps<IRental>> = ({ member }) => {
  const navigate = useNavigate()
  const onBack = () => navigate(Routes.Rental.member(`${member.id}`).show)
  const { titlelizer } = useTitle({ route: { key: `${RecordType.rental}.damage` } })

  const title = titlelizer({ rental_code: member?.rentalCode })
  const subtitle = member?.project?.name

  return <KTitle title={title} subtitle={subtitle} onBack={onBack} />
}

export default DamagesTitle
